"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var app_1 = __importDefault(require("firebase/app"));

require("firebase/auth");

require("firebase/firestore");

require("firebase/storage");

var firebase_1 = __importDefault(require("../../configs/firebase"));

function default_1() {
  var isDev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var isUseEmulator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var host = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "localhost";
  var port = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8080;

  try {
    app_1.default.initializeApp(firebase_1.default);

    if (isUseEmulator) {
      app_1.default.firestore().useEmulator(host, port);
    }
  } catch (err) {
    if (!isDev) {
      throw err;
    } else {
      if (!/already exists/.test(err.message)) {
        console.error("Firebase initialization error raised", err.stack);
      }
    }
  }
}

exports.default = default_1;